import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main flex h-screen flex-col" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div id=\"modal\"></div><div id=\"modalNotification\"></div><a id=\"btnTop\" class=\"bg-green-700 text-white\" href=\"#\" title=\"Ir para o Topo\"><svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"h-6 w-6\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12 19.5v-15m0 0l-6.75 6.75M12 4.5l6.75 6.75\"></path></svg></a>", 3)

import Rodape from './components/Rodape.vue';
import { onMounted } from 'vue';

// Verifica se é um redirecionamento após logout do Keycloak e precisa fazer logout no GOV.BR

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

onMounted(() => {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('govbr_logout') === 'true') {
    const govBrLogoutUrl = urlParams.get('govbr_logout_url');
    if (govBrLogoutUrl) {
      // Redireciona para o logout do GOV.BR
      window.location.href = decodeURIComponent(govBrLogoutUrl);
      return;
    }
  }
});

window.onscroll = function () {
  scrollFunction();
};

function scrollFunction() {
  const button = document.getElementById('btnTop');
  if (button) {
    button.style.display = document.body.scrollTop > 20 || document.documentElement.scrollTop > 20 ? 'block' : 'none';
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view, { class: "flex-grow" }),
      _createVNode(Rodape, { class: "bottom-0" })
    ]),
    _hoisted_2
  ], 64))
}
}

})